import { DOWNLOAD_REQUESTS } from "constants/routes";
import { serviceRoles } from "config/access";
import { checkAccess } from "helpers/auth";
import DownloadRequestPage from "./container/DownloadRequestPage";

export default function getSettingsRoute(userAuth) {
  const { account } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: DOWNLOAD_REQUESTS,
    withSidebar: true,
    withAppBar: true,
    component: DownloadRequestPage,
  };
}
